import * as React from "react";
import { Portal } from "react-portal";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { create } from "zustand";
import styles from "./Popin.module.less";

export const store = create<{ popins: Array<string> }>(() => ({ popins: [] }));
export const overlayId = "PopinOverlay";

export const show = (id: string): void => {
  store.setState((prevState) => ({ popins: [...prevState.popins, id] }));
};

export const close = (id: string): void => {
  store.setState((prevState) => ({ popins: prevState.popins.filter((_id) => _id !== id) }));
};

export const closeLast = (id: string): void => {
  store.setState((prevState) => ({ ...prevState, [id]: "closing" }));
  if (store.getState().popins.length > 0) {
    const _id = store.getState().popins[store.getState().popins.length - 1];
    if (_id === id) close(id);
  }
};

const PopinManager: React.FC = () => {
  const [isClosing, setIsClosing] = React.useState(false);
  const popins = store((state) => state.popins);

  React.useEffect(() => {
    const unsub = store.subscribe((state, prevState) => {
      if (state.popins.length === 0 && prevState.popins.length === 1) {
        setIsClosing(true);
      }
    });

    return () => {
      unsub();
    };
  }, []);

  const overlayClass = cls({
    [styles.popinOverlay]: isClosing || popins.length > 0,
    [styles.popinOverlayFadeOut]: isClosing && popins.length === 0,
  });

  return (
    <Portal node={document && document.getElementById("app")}>
      <div id={overlayId} role="presentation" className={overlayClass} onAnimationEnd={() => setIsClosing(false)} />
    </Portal>
  );
};

export default PopinManager;
